import { FlexLayout, GridLayout, H4, Icon } from '@deity/falcon-ui';
import { ToggleSwitch, Tooltip } from 'components';
import _ from 'lodash';
import type { FC } from 'react';
import type { IContainerChildrenProps } from 'utils';

interface IPropertyContainerProps extends IContainerChildrenProps {
  property: string;
  defaultValue: any | undefined;
  description: string | undefined;
  showProperty: boolean;
  locked?: boolean;
  required?: boolean;
  onOverride?: (key: string, setOverride: boolean, defaultOverrideValue?: any) => void;
  defaultOverrideValue?: any;
}
const PropertyContainer: FC<IPropertyContainerProps> = ({
  property,
  defaultValue,
  description,
  showProperty,
  required,
  onOverride,
  children,
  locked,
  defaultOverrideValue
}) => (
  <GridLayout gridTemplateColumns="2fr 1fr 1fr" p="xs" width="full">
    <FlexLayout alignItems="center" flexWrap="nowrap">
      <H4 mr="xs" css={{ textTransform: 'capitalize' }}>
        {property}
      </H4>
      {description && (
        <Tooltip content={description} direction="right">
          <Icon src="helpOutline" color="secondary" stroke="transparent" />
        </Tooltip>
      )}
    </FlexLayout>
    <FlexLayout alignItems="center" flexWrap="nowrap" justifySelf="center">
      <H4>{_.isUndefined(defaultValue) ? '-' : defaultValue.toString()}</H4>
    </FlexLayout>
    <FlexLayout alignItems="center" flexWrap="nowrap" justifySelf="end">
      {!required && (
        <ToggleSwitch
          disabled={locked}
          defaultValue={showProperty}
          onChange={val => {
            if (locked || !onOverride) {
              return;
            }
            onOverride(property, val, defaultOverrideValue);
          }}
        />
      )}
    </FlexLayout>
    {/* only Render children when shown. if not, the value(/state) is reused when rendered again */}
    {showProperty && children}
  </GridLayout>
);

export default PropertyContainer;
